const MAX_INT32 = 2_147_483_647;
const MAX_INT32_LABEL = MAX_INT32.toLocaleString('en-US');

export const int32Error = (
  invalidMessage: string,
  tooBigMessage = `Value must not exceed ${MAX_INT32_LABEL}`
) => ({
  error: (iss: { code: string }) =>
    iss.code === 'too_big' ? tooBigMessage : invalidMessage,
});
